import { r as registerInstance, h, H as Host } from './index-16dc7dde.js';
import { c as classnames } from './index-136476ff.js';
import './request.constants-deb285e0.js';
import { D as DEFAULT_LINE_HEIGHT } from './description-8e9c566a.js';
import { a as isMobile } from './utils-15ad90ec.js';
import { p as pesIconSizes, a as pesIconMirrorDirection } from './constants-e9ddcc22.js';
import './_commonjsHelpers-ba3f0406.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './lookups-705fb53e.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const descriptionCss = ".show-button{display:inline-flex;align-items:center;margin:10px 0;background:none;border:none;font-size:1rem;cursor:pointer;outline:inherit;padding:0;color:#42b4e6}@media screen and (max-width: 979px){.show-button{display:flex;gap:17px}}@media screen and (min-width: 980px){.show-button{font-size:1rem}:host(.light) .show-button{color:#ffffff}}:host(.dark) .show-button{color:#42b4e6}:host(:not([dir=\"rtl\"])) .show-button__text{margin-right:3px}:host([dir=\"rtl\"]) .show-button__text{margin-left:3px}.show-button__text:hover{text-decoration:underline}@media screen and (min-width: 980px){.description-text{height:auto}:host(.light) .description-text{color:#ffffff}}.description-text--safari{overflow:hidden;text-overflow:ellipsis;font-size:1rem;line-height:1.5rem;margin:16px 0 0}:host(.category) .description-text--safari{margin:24px 0 0}.text-container.expanded{-webkit-line-clamp:unset}.text-container{display:block;margin:16px 0 0;font-size:1rem;line-height:1.5rem;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden}.text-container a{text-decoration:none;outline:none;color:#42b4e6}.text-container a:hover{text-decoration:underline}.text-container p{margin:0}@media screen and (min-width: 980px){.text-container{display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;overflow:hidden}}:host(.category) .text-container{margin:24px 0 0}@media screen and (min-width: 980px){.text-container--banner{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}}.blurred-text{z-index:1;position:relative}:host(:not([dir=\"rtl\"])) .blurred-text{box-shadow:white 1px -3px 11px 8px}:host([dir=\"rtl\"]) .blurred-text{box-shadow:white -1px -3px 11px 8px}.font-m{font-size:14px;line-height:1.4285714286}.description__content{color:#626469}@media screen and (max-width: 979px){.description__content{margin-bottom:12px}}@media screen and (min-width: 980px){.description__content{width:780px}}.blurred-text{box-shadow:white 0px -19px 9px 11px;z-index:1;position:relative}.pdp-long-desc{text-align:justify;margin:unset}.pdp-long-desc>.pes-ellipsis{text-align:justify}";

let Description = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.numLinesToShow = { desktop: 5, mobile: 4 };
    this.isBanner = false;
    this.isPdp = false;
    this.variant = 'dark';
    this.isExpanded = false;
    this.isShowReadMore = false;
    this.getHeightLimit = () => {
      const { desktop, mobile } = this.numLinesToShow;
      const numLinesToShow = isMobile() ? mobile : desktop;
      const pStyle = window.getComputedStyle(this.paragraph, null);
      const lineHeight = (pStyle === null || pStyle === void 0 ? void 0 : pStyle.lineHeight) !== 'normal' ? pStyle.lineHeight : DEFAULT_LINE_HEIGHT;
      return numLinesToShow * parseInt(lineHeight, 10);
    };
    this.getShowReadMore = () => {
      var _a;
      if (this.isSafariBrowser() && this.isShowReadMore)
        return true;
      return (((_a = this.paragraph) === null || _a === void 0 ? void 0 : _a[this.isSafariBrowser() ? 'clientHeight' : 'scrollHeight']) > this.heightLimit);
    };
    this.handleResizeWindow = () => {
      this.heightLimit = this.getHeightLimit();
      this.isShowReadMore = this.getShowReadMore();
    };
    this.handleClick = () => {
      this.isExpanded = !this.isExpanded;
      if (!this.isSafariBrowser() && this.paragraph) {
        this.paragraph.classList.toggle('expanded');
      }
    };
  }
  componentDidLoad() {
    this.heightLimit = this.getHeightLimit();
    this.isShowReadMore = this.getShowReadMore();
    window.addEventListener('resize', this.handleResizeWindow);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResizeWindow);
  }
  getWrapped(text) {
    return `<!--GEN_DESC_BEGIN-->${text}<!--GEN_DESC_END-->`;
  }
  renderSafariText() {
    return (h("p", { class: classnames('description-text description-text--safari', { 'pdp-long-desc': this.isPdp }), ref: (el) => (this.paragraph = el) }, this.isShowReadMore ? (h("pes-ellipsis", { maxHeight: this.isExpanded ? 'none' : `${this.heightLimit}px`, content: this.getWrapped(this.text), isPdpDesc: this.isPdp })) : (h("span", { innerHTML: this.getWrapped(this.text) }))));
  }
  renderText() {
    return (h("div", { class: classnames('text-container', { 'pdp-long-desc': this.isPdp }, {
        'text-container--banner': this.isBanner,
      }), ref: (el) => {
        this.paragraph = el;
      } }, h("span", { class: classnames({ 'description__content font-m': this.isPdp }, { 'description-text': !this.isPdp }), innerHTML: this.getWrapped(this.text) })));
  }
  isSafariBrowser() {
    return (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1);
  }
  render() {
    if (!this.text)
      return null;
    return (h(Host, { class: this.variant }, this.isSafariBrowser() ? this.renderSafariText() : this.renderText(), this.isPdp && this.isShowReadMore && this.getShowReadMore() && (h("div", { class: this.isExpanded ? '' : 'blurred-text' }, '')), this.isShowReadMore && this.getShowReadMore() && (h("button", { type: "button", class: "show-button", onClick: this.handleClick }, h("span", { class: classnames('show-button__text', { 'font-m': this.isPdp }) }, this.isExpanded ? this.collapseLabel : this.expandLabel), h("pes-icon", { size: this.isPdp ? pesIconSizes.NANO : pesIconSizes.MICRO, mirror: this.isExpanded ? pesIconMirrorDirection.VERTICAL : undefined }, "arrow2_down")))));
  }
};
Description.style = descriptionCss;

export { Description as pes_description };
